import { defineStore } from 'pinia';
import Authentication from 'src/boot/services/Authentication';
import Objectives from 'src/boot/services/Objectives';
import { ObjectiveHistory } from 'src/types';
type ObjectiveHistoryMode = {
  date: string;
  corrects: number;
  wrong: number;
};

export const useHistory = defineStore('history', {
  state: () => ({
    history: [] as ObjectiveHistory[],
    historyByDate: [] as ObjectiveHistoryMode[],
    totalDaysStudied: 0,
  }),
  getters: {
    getSubjects() {
      return (
        Authentication.loggedUser()?.contest.subjects.map((el) => el.subject) ||
        []
      );
    },
  },
  actions: {
    async fetchAllHistory() {
      const response = await Objectives.fetchQuestionsHistory({
        where: {
          marked_alternative: {
            $nin: [''],
          },
        },
        max: 1,
        headers: {
          'Cache-control': 'no-cache',
        },
      });
      const data = response?.data._meta.total || 0;
      return data;
    },
    async fetchCorrectHistory() {
      const response = await Objectives.fetchQuestionsHistory({
        where: {
          scored: true,
          marked_alternative: {
            $nin: [''],
          },
        },
        max: 1,
        headers: {
          'Cache-control': 'no-cache',
        },
      });
      const data = response?.data._meta.total || 0;
      return data;
    },
    async fetchWrongHistory() {
      const response = await Objectives.fetchQuestionsHistory({
        where: {
          scored: false,
          marked_alternative: {
            $nin: [''],
          },
        },
        max: 2000,
        headers: {
          'Cache-control': 'no-cache',
        },
      });
      const data = response?.data._items || [];
      this.$state.history = data;
      return data;
    },
    async fetchHistoryBySubject() {
      const response = await Objectives.fetchQuestionsHistory({
        where: {
          subject: {
            $in: this.getSubjects,
          },
          // scored: true,
          marked_alternative: {
            $nin: [''],
          },
        },
        max: 2000,
        headers: {
          'Cache-control': 'no-cache',
        },
      });
      const data = response?.data._items || [];
      this.$state.history = data;
      return data;
    },
    async fetchDaysStudied() {
      const response = await Objectives.fetchDaysStudied();
      if (response) {
        this.$state.totalDaysStudied = response.data._meta.total;
      }
    },
    async fetchAllDaysStudied() {
      const set = new Set()
      const obj1 = await Objectives.fetchDaysStudied('objective');
      const obj2 = await Objectives.fetchDaysStudied('evaluation');
      const obj3 = await Objectives.fetchDaysStudied('simulation');

      if(obj1) obj1.data._items.forEach(el => set.add(el))
      if(obj2) obj2.data._items.forEach(el => set.add(el))
      if(obj3) obj3.data._items.forEach(el => set.add(el))

      return set.size
    },
  },
});
